/**
 * 时时彩，通用模板，待投注列表
 */
import { connect } from 'react-redux'
import ReactDOM from 'react-dom';
import Loader from '../../../components/icon/Loader.jsx';
import { DOMAIN } from '../../../constants/config'
import Popup from '../../../components/modal/popup.jsx';

class BetHistory extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      detailUrl: null,
      showDetail: false,
      currentItem: null,
      showCodeName: null,
      showCurrentItem: null
    }
    this.hideCodeDtail = this.hideCodeDtail.bind(this);
    this.openModal = this.openModal.bind(this);
    this.showCodeDtail = this.showCodeDtail.bind(this);
    this.hideAllCode = this.hideAllCode.bind(this);
    this.openModal = this.openModal.bind(this); 
    this.showAllCode = this.showAllCode.bind(this)
  }

  componentWillUnmount() {
   if (this.fetchTimer) {
    window.clearTimeout(this.fetchTimer);
    this.fetchTimer = null;
   }
  }

  // 打开弹出框
  openModal(url, title, width, height){
    this.props.$$BASE.openIframeModal(url, title, width, height);
  }

  closeDetail() {
    this.setState({
      showDetail:false
    })
  }

  showCodeDtail(encoded_id) {
    this.setState({
      currentItem: encoded_id
    })
  }

  hideCodeDtail() {
    this.setState({
      currentItem:null
    })
  }

  showAllCode(index) {
    this.setState({
      showCodeName: "active",
      showCurrentItem:index
    })
  }
  
  hideAllCode() {
    this.setState({
      showCodeName: ""
    })
  }

  // 刷新用户最近投注
  refreshUserBetHis(){
    if (this.fetching) {
      return this.props.$$BASE.openToast('您操作过于频繁，请稍后再试');
    }
    this.fetchTimer = window.setTimeout(function(){
      this.fetching = false;
    }.bind(this), 5000)
    this.fetching = true;
    this.props.$$USER.getUserBetRecent();
  }

  render() {
    const __user = this.props.__USER.toJS();

    return (
      <div className="bettingRecord outer-con">
        <div className="warp lotteryHistory-container" id="close_bet-record_tc">

          <div className="lotteryHistoryBody">
            <h3>
                <span>投注记录</span>
            </h3>
            <table width="100%">
              <tbody>
                <tr>
                  {/*<th width="14%">投注时间</th>*/}
                  <th>彩种</th>
                  {/*<th width="12%">期号</th>*/}
                  {/*<th>玩法</th>*/}
                  {/*<th width="14%">投注内容</th>*/}
                  <th>投注金额</th>
                  <th>奖金</th>
                  {/*<th width="12%">开奖号码</th>*/}
                  <th>状态</th>
                </tr>
                {
                  __user.recentBet ?
                    __user.recentBet.map((item, index) =>
                      <tr key={index}>
                        {/*<td>{item.created_at}</td>*/}
                        <td>{item.lottery}</td>
                        {/*<td>{item.issue}</td>*/}
                        {/*<td>{item.method}</td>*/}
                        {/*<td>{*/}
                          {/*item.code.length < 24 ? item.code : <span className="detailCode" onClick={this.showCodeDtail.bind(this, item.encoded_id)}>详细号码</span>*/}
                        {/*}*/}
                          {/*<div className={(this.state.currentItem==item.encoded_id) ? 'task_div' : 'task_div_hidden'}>*/}
                            {/*<p>号码详情*/}
                            {/*<a href="javascript:;" onClick={this.hideCodeDtail}>[关闭]</a>*/}
                            {/*</p>*/}
                            {/*<div className="code">{item.code}</div>*/}
                          {/*</div>*/}
                        {/*</td>*/}
                        <td>{item.total_price}</td>
                        <td className={item.bonus > 0 ? 'prize' : ''}>{item.bonus}</td>
                        {/*{*/}
                          {/*item.bonus_code == null ?*/}
                            {/*<td className="winningNumber"><span>{item.bonus_code || '- - - - -'}</span></td> :*/}
                            {/*<td className="winningNumber"><span onMouseOver={item.bonus_code.length > 14 ? this.showAllCode.bind(this, index) : null} onMouseLeave={this.hideAllCode} className={(this.state.showCurrentItem == index) ? this.state.showCodeName : ""}>{item.bonus_code || '- - - - -'}</span></td>*/}
                        {/*}*/}
                        <td className={
                          item.status_desc == "未中奖"?
                            'pointer' : item.status_desc == "已派奖" || item.status_desc == "未派奖"?
                              'pointer orange' : item.status_desc == "可撤单" || item.status_desc == "本人撤单" || item.status_desc == "未开奖"?'pointer green' : 'pointer blue'
                        }
                          onClick={this.openModal.bind(this, 'gameinfo/newgamedetail/' + item.encoded_id + '?isback=0', '注单详情', 980, 600)}>
                          <span className="desc_btn">
                            {item.status_desc=="可撤单"?"未开奖":item.status_desc=="未派奖"?"派奖中":item.status_desc}
                          </span>
                        </td>
                      </tr>
                      ) : <tr><td colSpan="9"><Loader /></td></tr>
                }
              </tbody>
            </table>
          </div>
           {/*<a onClick={() => this.refreshUserBetHis()}>*/}
               {/*刷新*/}
           {/*</a>*/}
            {
                __user.recentBet instanceof Array && __user.recentBet.length >= 6 ?
                    <div className='goBetHistory' onClick={this.openModal.bind(this, 'gameinfo/newgamelist?username=' + __user.info.username, '投注记录', 980, 600)}>查看更多</div>
                    :
                    null
            }
        </div>
      </div>
    )
  }
}

reactMixin(BetHistory.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetHistory)